<template>
    <div>
        <b-row>
            <b-col>
                <b-table hover small show-empty class="sr-caption"
                    aria-live="polite"
                    responsive="true"
                    :fields="attachmentFields"
                    :items="value"
                    :busy="false"
                    label-sort-asc=""
                    label-sort-desc=""
                    caption="Uploads table.  To sort the data in this table by a specific column,
                                       go to the appropriate column header cell and use enter to sort the data ascending.
                                       Use enter again to sort descending.">
                    <template v-slot:no-data>
                        No Uploads Found.
                    </template>
                    <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle" label="Loading, Please Wait" aria-label="Loading, Please Wait"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                    <template v-slot:cell(actions)="row">
                      <span class="no-print">
                        <b-button size="sm" @click="downloadAttachment(row)" target="_attach" class="mr-1">
                            Download
                        </b-button>
                        <b-button v-if="!readonly" size="sm" @click="showRemoveModal(row.item)" target="_attach" class="mr-1">
                            Remove
                        </b-button>
                      </span>
                    </template>
                    <template slot="empty" slot-scope="scope">
                        No Uploads Found.
                    </template>
                </b-table>
            </b-col>
        </b-row>

        <b-modal size="xl" :id="'remove-modal' + modalId" hide-header hide-footer>
            <h2>Are you sure you want to remove file {{file.filename}}?</h2>
            <b-button variant="primary" @click="removeAttachment()">Confirm</b-button>
            <b-button @click="hideRemoveModal" variant="secondary">Close</b-button>
        </b-modal>
    </div>
</template>

<script>
    import axios from 'axios';
    import {toastService} from "@/mixins/toastService"

export default {
    data() {
        return {
            attachmentFields:  [],
            file: {}
        }
    },
    props: {
        value: Array,
        hasRelationship: {
          default: false,
          type: Boolean
        },
        readonly: {
          default: false,
          type: Boolean
        },
        modalId: [String]
    },
    mixins: [
        toastService
    ],
    created() {
        if (this.hasRelationship) {
          this.attachmentFields = [
            {key: 'filename', sortable: false, label: 'File Name'},
            {key: 'type.description', sortable: false, label: 'File Type'},
            {key: 'relationship.description', sortable: false, label: 'Relationship'},
            {key: 'actions', label: 'Actions'},
          ]
        } else {
            this.attachmentFields = [
                {key: 'filename', sortable: false, label: 'File Name'},
                {key: 'type.description', sortable: false, label: 'File Type'},
                {key: 'actions', label: 'Actions'},
            ]
        }
    },
    methods:{
        showRemoveModal(current){
            this.file = current
            this.$bvModal.show('remove-modal' + this.modalId)
        },
        hideRemoveModal(){
            this.$bvModal.hide('remove-modal' + this.modalId)
            this.file = {}
        },
        downloadAttachment(row){
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/attachments/getUrl/`+row.item.attachmentId)
                .then(response=>{
                    if(response.data){
                        window.open(response.data,"_blank");
                    }
                    else{
                        this.$emit('attachment-get-failure')
                    }
                })
        },
        removeAttachment() {
            const fileId = this.file.attachmentId
            axios.delete(`${process.env.VUE_APP_API_BASE_URL}/attachments/`+ fileId)
                .then(response => {
                    this.$emit('attachment-removed', fileId)
                    toastService.showRootToast("Success", "File Successfully Removed", "success", this.$root)
                }).catch(error=> {
                    toastService.showRootToast("Delete Failed", "Unable to Remove File", "danger", this.$root)
            }).finally(()=>{
                this.hideRemoveModal()
            })
        }
    }
}
</script>

<style>
</style>
